<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div><strong>Bank Name</strong></div>
          <div>{{ bankData.bankName  }}</div>
          <div><strong>ABA/Routing Number</strong></div>
          <div>{{ bankData.routingNumber }}</div>
          <div><strong>Account Number</strong></div>
          <div>{{ bankData.accountNumber  }}</div>
          <div><strong>Account Name</strong></div>
          <div>{{ bankData.accountName  }}</div>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <div class="text-center bottom-border">
            <strong>Bank Address</strong>
          </div>
          <address-display class="mt-2" :address="bankData.bankAddress"/>
        </b-col>
        <b-col>
          <div class="text-center bottom-border">
            <strong>Recipient Address</strong>
          </div>
          <address-display class="mt-2" :address="bankData.recipientAddress"/>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import AddressDisplay from '@/components/utils/address/AddressDisplay';

export default {
  components: {
    AddressDisplay,
  },
  props: {
    bankData: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/payments/display/BankDetailsDisplay.vue